const en_master_category = {
    add: "add category",
    code: "category code",
    name: "category name",

    error: {
        code: "Category code cannot be empty.",
        name: "Category name cannot be empty.",
        create: "Failed to create category.",
        delete: "Failed to delete category.",
        edit: "Failed to update category.",
    },

    success: {
        create: "Category created successfully.",
        delete: "Category deleted successfully.",
        edit: "Category updated successfully.",
    }
}

export default en_master_category;